import { createReducer, on } from '@ngrx/store';
import { TrackerCoreActions } from '../actions';
import { trackerState } from '../tracker.state';
import { TrackerState } from '../tracker.state.interface';

// Core action handlers - these return `on` functions that can be used in createReducer
export const trackerCoreHandlers: Array<
  Parameters<typeof createReducer<typeof trackerState>>[1]
> = [
  on(
    TrackerCoreActions.reset,
    (): TrackerState => ({
      ...trackerState
    })
  ),
  on(
    TrackerCoreActions.update,
    (state, { tracker }): TrackerState => ({ ...state, ...tracker })
  ),
  on(TrackerCoreActions.resetTrackerData, (state) => ({
    ...state,
    bodyBatteryDetailQuery: {
      ...trackerState.bodyBatteryDetailQuery
    },
    dailyHealthSnapshotQuery: {
      ...trackerState.dailyHealthSnapshotQuery
    },
    sleepDetailQuery: {
      ...trackerState.sleepDetailQuery
    },
    stressDetailQuery: {
      ...trackerState.stressDetailQuery
    },
    caloriesDetailQuery: {
      ...trackerState.caloriesDetailQuery
    },
    stepsDetailQuery: {
      ...trackerState.stepsDetailQuery
    },
    distanceDetailQuery: {
      ...trackerState.distanceDetailQuery
    },
    oxygenSaturationDetailQuery: {
      ...trackerState.oxygenSaturationDetailQuery
    },
    heartRateDetailQuery: {
      ...trackerState.heartRateDetailQuery
    },
    trackerOverviewQuery: trackerState.trackerOverviewQuery
  })),
  on(TrackerCoreActions.fetchConnectedTrackers, (state) => ({
    ...state,
    connectedTrackerQuery: {
      ...state.connectedTrackerQuery,
      loading: true,
      error: undefined,
      fetchCount: state.connectedTrackerQuery.fetchCount + 1
    }
  })),
  on(TrackerCoreActions.fetchConnectedTrackersSuccess, (state, payload) => {
    return {
      ...state,
      connectedTrackerQuery: {
        ...state.connectedTrackerQuery,
        loading: false,
        error: undefined,
        data: payload
      }
    };
  }),
  on(TrackerCoreActions.fetchConnectedTrackersFailed, (state, payload) => {
    return {
      ...state,
      connectedTrackerQuery: {
        ...state.connectedTrackerQuery,
        loading: false,
        error: payload.error
      }
    };
  }),
  on(TrackerCoreActions.setActiveTracker, (state, payload) => ({
    ...state,
    activeTracker: payload.activeTracker
  })),
  on(TrackerCoreActions.fetchDailyHealthSnapshot, (state) => ({
    ...state,
    dailyHealthSnapshotQuery: {
      ...state.dailyHealthSnapshotQuery,
      loading: true,
      error: undefined,
      fetchCount: state.dailyHealthSnapshotQuery.fetchCount + 1
    }
  })),
  on(TrackerCoreActions.fetchDailyHealthSnapshotSuccess, (state, payload) => ({
    ...state,
    dailyHealthSnapshotQuery: {
      ...state.dailyHealthSnapshotQuery,
      loading: false,
      error: undefined,
      data: payload.data,
      latestDate: new Date().toISOString().split('T')[0]
    }
  })),
  on(TrackerCoreActions.fetchDailyHealthSnapshotFailed, (state, payload) => ({
    ...state,
    dailyHealthSnapshotQuery: {
      ...state.dailyHealthSnapshotQuery,
      loading: false,
      error: payload.error
    }
  }))
];
